<template>
  <div class="d-flex" style="min-height: 45vw">
    <div class="content p-4 w-100">
      <div class="d-flex">
        <h4 class="card-title mt-0">
          {{ i18n.global.t('pages.groups.title.list') }}
        </h4>
      </div>
      <div class="mb-5 d-flex justify-end">
        <div class="btn-area">
          <v-btn
            v-show="createAuthority"
            class="exec-btn mt-0"
            @click="moveToGroupForm"
          >
            {{ i18n.global.t('pages.common.button.newCreate') }}
          </v-btn>
          <FileDownloadBtn
            :showable="csvExportGroupAuthority"
            btnClass="exec-btn mt-0 ml-1"
            :btnName="i18n.global.t('pages.common.button.csvExport')"
            :type="downloadType"
            :filterItems="searchParams"
          />
          <v-btn
            v-show="csvImportGroupAuthority"
            class="exec-btn mt-0 ml-1"
            @click="activateModalState"
          >
            {{ i18n.global.t('pages.common.button.csvImport') }}
          </v-btn>
        </div>
      </div>
      <div>
        <GroupList
          class="mb-2"
          :groups="groups"
          :listLoading="listLoading"
          :changeStatusAuthority="changeStatusAuthority"
          :updatingStatus="updatingStatus"
          :isManagementOffice="isManagementOffice"
          :isSearchCompleted="isSearchCompleted"
          @changeStatus="updateStatus"
          @changeSortOrder="changeSortOrder"
        />
        <PaginateWithCount class="justify-end" :totalPage="totalPage" v-model="currentPage" :showItemCount="false" />
        <hr />
      </div>
    </div>
    <GroupsSearchForm
      :loading="listLoading"
      :isManagementOffice="isManagementOffice"
      :isSubManagementOffice="isSubManagementOffice"
      @search="getGroupsAfterSetParams"
      @clear="clearGroupSearchParams"
    />
    <FileUploadModal
      :modalState="modalState"
      :title="i18n.global.t('pages.groups.csv.input')"
      uploadBtnClass='exec-btn mt-0 ml-1'
      closeBtnClass='mt-0'
      :type="uploadType"
      templateCsvFileType="groups"
      @closeModal="inactivateModalState"
    />
  </div>
</template>

<script>
import GroupList from "@/components/GroupList";
import GroupsSearchForm from "@/components/GroupsSearchForm";
import Api from "@/services/api/ApiServiceFabrick";
import PaginateWithCount from "@/components/PaginateWithCount.vue";
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi";
import FileDownloadBtn from "@/components/Files/DownloadButton"
import FileUploadModal from "@/components/Files/UploadModal"
import { ref } from "vue";
import { useAuth } from "@/services/user/Auth0UserProvider";
import i18n from '@/lang/i18n';
import { saveDataToSessionStorage, loadDataFromSessionStorage, clearSessionStorage } from "@/services/functions/sessionStorage";
import { MANAGEMENT_OFFICE_TYPE, SUB_MANAGEMENT_OFFICE_TYPE } from "@/services/consts";

export default {
  props: {
    showFlash: {
      type: Function,
    },
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      groups: [],
      listLoading: false,
      isSearchCompleted: false,
      searchParams: {
        page: 1,
        withs: "operationOffice,accounts,updatedBy",
        status: "only-active",
      },
      updatingStatus: false,
      creatingOrUpdating: false,
      downloadType: "App\\Services\\Csv\\Exports\\GroupService",
      uploadType: "App\\Services\\Csv\\Imports\\GroupService",
      modalState: ref(false),
      isManagementOffice: false,
      isSubManagementOffice: false,
      changeStatusAuthority: false,
      createAuthority: false,
      csvImportGroupAuthority: false,
      csvExportGroupAuthority: false,
    };
  },
  setup() {
    document.title = i18n.global.t('pages.groups.title.list');
    const { loginWithRedirect } = useAuth();

    return {
      loginWithRedirect,
      i18n
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.searchParams.page = this.currentPage;
        this.getGroups();
      },
    },
  },
  mounted() {
    this.getAuthorityList()
    const savedSearchParams = loadDataFromSessionStorage('groupSearchParams')
    if (savedSearchParams) {
      this.searchParams = savedSearchParams
    }
    Api().getSelfAccount().then((data) => {
      this.isManagementOffice = data.login_organization_type == MANAGEMENT_OFFICE_TYPE
      this.isSubManagementOffice = data.login_organization_type == SUB_MANAGEMENT_OFFICE_TYPE
      if (!this.isManagementOffice || savedSearchParams) {
        this.getGroups()
      }
    })
  },
  methods: {
    async getAuthorityList(isError = false) {
      if (isError) {
        await AuthorityCacheApi.reflesh()
      }
      const authorityList = await AuthorityCacheApi.getWithParse()
      this.changeStatusAuthority = authorityList["octlink.group.delete"];
      this.createAuthority = authorityList["octlink.group.create"];
      this.csvImportGroupAuthority = authorityList["octlink.group.input"]
      this.csvExportGroupAuthority = authorityList["octlink.group.output"]
    },
    getGroups() {
      this.listLoading = true;

      Api()
        .getPaginatedGroups(this.searchParams)
        .then((data) => {
          this.groups = data.groups;
          this.currentPage = data.current_page;
          this.totalPage = data.total_page;
          this.listLoading = false;
          this.isSearchCompleted = true;
        })
        .catch((error) => {
          const res = error.response;
          switch (res.status) {
            case 401:
              this.loginWithRedirect({
                appState: { targetUrl: location.pathname },
              });
              break;
            case 403:
              location.reload();
              break;
            case 422:
              this.showFlash(
                i18n.global.t('pages.groups.errors.getGroupList'),
                "error",
                false
              );
          }
          this.listLoading = false;
        });
    },
    updateStatus(params) {
      this.updatingStatus = true;
      Api()
        .updateGroupStatus(params)
        .then((_data) => {
          this.showFlash(this.$t("pages.common.messages.changeStatusSuccess"), "success");
          this.updatingStatus = false;
          this.getGroups();
        })
        .catch((error) => {
          const res = error.response;
          switch (res.status) {
            case 401:
              this.loginWithRedirect({
                appState: { targetUrl: location.pathname },
              });
              break;
            case 403:
              this.showFlash(this.$t("pages.common.messages.forbidden"), "error", false)
              this.getAuthorityList(true);
              break;
            case 422:
              this.showFlash(
                this.$t("pages.common.messages.changeStatusFail"),
                "error",
                false
              );
          }
          this.updatingStatus = false;
        });
    },
    getGroupsAfterSetParams(searchParams) {
      searchParams.page = 1;
      searchParams.withs = this.searchParams.withs;
      searchParams.sort = this.searchParams.sort;
      searchParams.sort_type = this.searchParams.sort_type;
      this.searchParams = searchParams;
      saveDataToSessionStorage('groupSearchParams', this.searchParams);
      this.getGroups();
    },
    changeSortOrder(sortItem, sortType) {
      this.searchParams.sort = sortItem;
      this.searchParams.sort_type = sortType;
      if (this.currentPage == 1) {
        this.getGroups();
      } else {
        this.currentPage = 1;
      }
    },
    moveToGroupForm() {
      this.$router.push("/groups/form/");
    },
    inactivateModalState (isReacquireGroup) {
      this.modalState = false
      if (isReacquireGroup) {
        this.getGroups()
      }
    },
    activateModalState () {
      this.modalState = true
    },
    clearGroupSearchParams() {
      clearSessionStorage('groupSearchParams')
    }
  },
  components: {
    GroupList,
    GroupsSearchForm,
    PaginateWithCount,
    FileDownloadBtn,
    FileUploadModal,
  },
};
</script>
